<app-custom-dropdown
  data-automation-id="search-res-sort"
  [aria-label]="'sortedBy' | translate"
  [focus$]="focus$"
  [selectedOption]="value.sorting+':'+value.sortOrder"
  (change)="onDropdownChange($event)">
  <span custom-dropdown-label translate>sortedBy</span>
  <app-custom-dropdown-option
    [value]="SORTING_OPTIONS[0].key"
    translate
    [id]="SORTING_OPTIONS[0].key"
    data-automation-id="search-res-sort-relevance-asc">
    sortedByRelevancy
  </app-custom-dropdown-option>
  <app-custom-dropdown-option
    [value]="SORTING_OPTIONS[1].key"
    [id]="SORTING_OPTIONS[1].key"
    translate>sortedByDateNewest</app-custom-dropdown-option>
  <app-custom-dropdown-option
    [value]="SORTING_OPTIONS[2].key"
    [id]="SORTING_OPTIONS[2].key"
    translate>sortedByDateOldest</app-custom-dropdown-option>
  <app-custom-dropdown-option
    *ngIf="!isRapido"
    [value]="SORTING_OPTIONS[3].key"
    [id]="SORTING_OPTIONS[3].key"
    translate>sortedByNewMaterials</app-custom-dropdown-option>
</app-custom-dropdown>
